export default "__VITE_ASSET__C8z0jRTt__"